<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <el-row :gutter="20">
        <!-- 左侧日志文件列表 -->
        <el-col :span="8">
          <el-card shadow="never">
            <div slot="header">
              <span>日志文件列表</span>
              <el-button
                style="float: right"
                type="primary"
                size="mini"
                icon="el-icon-refresh"
                @click="getFileList"
              >
                刷新
              </el-button>
            </div>
            <el-table
              v-loading="fileLoading"
              :data="fileList"
              style="width: 100%"
              max-height="600"
              highlight-current-row
              @row-click="handleFileClick"
            >
              <el-table-column type="index" label="序号" width="50" align="center" />
              <el-table-column prop="filename" label="文件名" show-overflow-tooltip />
              <el-table-column prop="size_alias" label="大小" width="90" align="center" />
              <el-table-column label="操作" width="70" align="center">
                <template slot-scope="{row}">
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-download"
                    @click.stop="handleDownload(row)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>

        <!-- 右侧日志内容 -->
        <el-col :span="16">
          <el-card shadow="never">
            <div slot="header">
              <span>{{ currentFile || "请选择日志文件" }}</span>
              <el-button
                v-if="currentFile"
                style="float: right; margin-left: 10px;"
                size="mini"
                icon="el-icon-refresh"
                @click="getLogContent"
              >
                刷新
              </el-button>
              <el-button
                v-if="currentFile"
                style="float: right"
                size="mini"
                :type="autoRefresh ? 'warning' : 'default'"
                @click="toggleAutoRefresh"
              >
                {{ autoRefresh ? "停止自动刷新" : "自动刷新" }}
              </el-button>
            </div>
            <div v-loading="contentLoading" style="min-height: 400px;">
              <div v-if="!currentFile" class="empty-tip">
                请从左侧列表选择一个日志文件查看内容
              </div>
              <div v-else>
                <el-form size="mini" :inline="true">
                  <el-form-item label="级别">
                    <el-select
                      v-model="searchCondition.level"
                      clearable
                      placeholder="全部"
                      style="width: 130px"
                    >
                      <el-option v-for="item in levelOptions" :key="item" :label="item" :value="item" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="关键字">
                    <el-input
                      v-model="searchCondition.keyword"
                      placeholder="日志内容关键字"
                      clearable
                      style="width: 200px"
                      @keyup.enter.native="handleSearch"
                    />
                  </el-form-item>
                  <el-form-item label="日期">
                    <el-date-picker
                      v-model="searchCondition.date_value"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      style="width: 240px"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
                  </el-form-item>
                </el-form>
                <el-table
                  :data="logContent"
                  style="width: 100%"
                  size="small"
                  max-height="500"
                  stripe
                >
                  <el-table-column type="index" label="行号" width="60" align="center" />
                  <el-table-column prop="time" label="时间" min-width="140" show-overflow-tooltip />
                  <el-table-column prop="level" label="级别" width="90" align="center">
                    <template slot-scope="{row}">
                      <el-tag v-if="row.level" size="mini" :type="levelTagType(row.level)">{{ row.level }}</el-tag>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="channel" label="通道" width="100" show-overflow-tooltip />
                  <el-table-column label="日志内容" min-width="480">
                    <template slot-scope="{row}">
                      <div>
                        <span class="message cursor-pointer" @click="clickCopyField(row, 'message')">
                          {{ row.message || "-" }}</span>
                        <span class="context cursor-pointer" @click="clickCopyField(row, 'context')">
                          {{ row.context || "-" }}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="currentFile"
                  background
                  :current-page="pagination.page"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pagination.pageSize"
                  :total="pagination.total"
                  layout="total, sizes, prev, pager, next, jumper"
                  style="margin-top: 15px; text-align: right;"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </PageHeaderLayout>
</template>
<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'FileLogList',
  components: { PageHeaderLayout },
  data() {
    return {
      // 日志级别
      levelOptions: ['DEBUG', 'INFO', 'NOTICE', 'WARNING', 'ERROR', 'CRITICAL', 'ALERT', 'EMERGENCY'],
      // 文件列表loading
      fileLoading: false,
      // 日志文件列表
      fileList: [],
      // 当前选中文件
      currentFile: '',
      // 日志内容loading
      contentLoading: false,
      // 日志内容列表
      logContent: [],
      // 搜索条件
      searchCondition: {
        level: '',
        keyword: '',
        date_value: []
      },
      // 分页信息
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      // 是否自动刷新
      autoRefresh: false,
      // 自动刷新定时器
      refreshTimer: null
    }
  },
  methods: {
    // 获取日志文件列表
    async getFileList() {
      this.fileLoading = true
      try {
        const list = await this.$api.getFileLogFiles()
        this.fileList = Array.isArray(list) ? list : []
      } catch (e) {
        this.fileList = []
      }
      this.fileLoading = false
    },
    // 点击文件行
    handleFileClick(row) {
      this.currentFile = row.filename
      this.pagination.page = 1
      this.getLogContent()
    },
    // 获取日志内容
    async getLogContent() {
      if (!this.currentFile) return
      this.contentLoading = true
      try {
        const searchCondition = this.handleSearchCondition()
        const params = Object.assign({
          filename: this.currentFile,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }, searchCondition)
        const { list, pages } = await this.$api.getFileLogList(params)
        this.logContent = list || []
        this.pagination.total = (pages && pages.total) || 0
      } catch (e) {
        this.logContent = []
        this.pagination.total = 0
      }
      this.contentLoading = false
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      if (this.searchCondition.level) {
        condition.level = this.searchCondition.level
      }
      if (this.searchCondition.keyword) {
        condition.keyword = this.searchCondition.keyword
      }
      if (this.searchCondition.date_value && this.searchCondition.date_value.length === 2) {
        condition.date_from = this.searchCondition.date_value[0]
        condition.date_to = this.searchCondition.date_value[1]
      }
      return condition
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getLogContent()
    },
    // 重置
    handleReset() {
      this.searchCondition = {
        level: '',
        keyword: '',
        date_value: []
      }
      this.pagination.page = 1
      this.getLogContent()
    },
    // 切换页码
    handlePageChange(page) {
      this.pagination.page = page
      this.getLogContent()
    },
    // 切换每页条数
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.page = 1
      this.getLogContent()
    },
    // 级别对应的tag类型
    levelTagType(level) {
      const upper = (level || '').toUpperCase()
      if (['DEBUG', 'INFO', 'NOTICE'].includes(upper)) {
        return 'info'
      }
      if (upper === 'WARNING') {
        return 'warning'
      }
      if (['ERROR', 'CRITICAL', 'ALERT', 'EMERGENCY'].includes(upper)) {
        return 'danger'
      }
      return ''
    },
    // 点击复制字段
    async clickCopyField(row, field) {
      const value = row[field]
      if (!value) {
        return
      }
      try {
        await this.$copyText(value)
        this.$message({ type: 'success', message: '已复制到剪贴板' })
      } catch (e) {
        this.$message({ type: 'error', message: '复制失败' })
      }
    },
    // 下载日志文件
    async handleDownload(row) {
      try {
        const response = await this.$api.downloadFileLog(row.filename)
        const contentType = response.headers && response.headers['content-type']
        const blob = new Blob([response.data], { type: contentType })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = row.filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
        this.$message({ type: 'success', message: '下载成功' })
      } catch (e) {
        this.$message({ type: 'error', message: '下载失败' })
      }
    },
    // 切换自动刷新
    toggleAutoRefresh() {
      this.autoRefresh = !this.autoRefresh
      if (this.autoRefresh) {
        this.refreshTimer = setInterval(() => {
          if (this.currentFile) {
            this.getLogContent()
          }
        }, 10000)
      } else {
        this.stopAutoRefresh()
      }
    },
    // 停止自动刷新
    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    }
  },
  mounted() {
    this.getFileList()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
  }
}
</script>

<style scoped>
.empty-tip {
  text-align: center;
  color: #999;
  padding: 100px 0;
}

.message::before {
  content: 'Message：';
  color: #67C23A;
  border-radius: 20px;
  border: #67C23A 1px solid;
  padding: 2px 8px;
  margin: 1px 8px;
  height: 20px;
  line-height: 20px;
}

.context::before {
  content: 'Context：';
  color: #E6A23C;
  border-radius: 20px;
  border: #E6A23C 1px solid;
  padding: 2px 8px;
  margin: 1px 8px;
  height: 20px;
  line-height: 20px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
